import { render, staticRenderFns } from "./CadPosto.vue?vue&type=template&id=ddd50f76&"
import script from "./CadPosto.vue?vue&type=script&lang=js&"
export * from "./CadPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports